<template>
  <div id="app">
    <top-nav></top-nav>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import TopNav from "./components/TopNav.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  components: {
    TopNav,
    Footer
  }
};
</script>

<style>
</style>
